import React, { useState } from 'react';
import { Provider, useSelector } from 'react-redux';
import store from '../../redux/store';

import { travelerLogin } from '../../service/travelerLoginService';
import { hasValidationErrors } from '../../lib/airframe/FormValidation';

import { CiriumWrapper } from '../../components/cirium/CiriumWrapper';
import { TravelerLoginCard } from './TravelerLoginCard';

import { selectImageUrl } from '../../redux/entities/brandingImage/brandingImageSelectors';
import { goTo } from '../../configTdm';

interface LoginValues {
  username: string;
  password: string;
  kwijybo: string;
}

interface ErrorResponse {
  message: string;
}

const TravelerLoginContainer: React.FC = () => {
  const [formDisabled, setFormDisabled] = useState(false);
  const [authError, setAuthError] = useState(false);
  const brandingImageUrl = useSelector(selectImageUrl);

  const travelerLoginInfo = (values: LoginValues) => ({
    username: values.username,
    password: values.password,
    kwijybo: values.kwijybo,
  });

  const handleLoginError = (response: ErrorResponse, addToast: (message: string, options: { appearance: 'success' | 'error' | 'info' | 'warning' }) => void) => {
    if (response.message.includes('Unauthorized')) {
      setAuthError(true);
    } else {
      addToast('Log in is temporarily unavailable', { appearance: 'error' });
    }
  };

  const handleLogin = (errors: any, values: LoginValues, addToast: (message: string, options: { appearance: 'success' | 'error' | 'info' | 'warning' }) => void) => {
    if (!hasValidationErrors(errors)) {
      setFormDisabled(true);
      travelerLogin(travelerLoginInfo(values))
        .then(response => {
          console.log('response', response);
          goTo(response.redirectPath);
        })
        .catch(error => {
          handleLoginError(error, addToast);
        })
        .finally(() => setFormDisabled(false));
    }
  };

  return (
    <CiriumWrapper loading={formDisabled}>
      <TravelerLoginCard
        handleLogin={handleLogin}
        loading={formDisabled}
        showError={authError}
        brandingImageUrl={brandingImageUrl}
      />
    </CiriumWrapper>
  );
};

const WrappedTravelerLoginContainer: React.FC = () => (
  <Provider store={store}>
    <TravelerLoginContainer />
  </Provider>
);

export default WrappedTravelerLoginContainer;